import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import React from 'react';
import apiClient from '../../shared/auth.interceptor';
import { firmRefresh } from '../../shared/auth.functions';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentRealm } from '../../shared/redux/currentRealmSlicer';
import { errorToast, warnToast } from '../../shared/toast.service';
import { RootState } from '../../../store';
import { MainRoute } from '../../../app';
import { UserRoute } from '../../user/userContainer';
import { setCurrentCompanyList } from '../../shared/redux/companySlicer';
import { initializeApp } from '../../../app.init';

export enum OAuthStatus {
  Success = 'OAuthSuccess',
  Error = 'OAuthError',
  AlreadyConnectedCompany = 'AlreadyConnectedCompany',
  DifferentRealmId = 'DifferentRealmId'
}

const Msg = () => (
  <div>
    <b> QuickBooks</b>
    <p> Opening your QuickBooks Account (popup window) to initiate the authorization </p>
  </div>
);
const useOAuth = () => {
  const currentFirm = useSelector((state: RootState) => state.currentFirm.currentFirm);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    const handleMessage = async (event: MessageEvent) => {
      if (event.origin !== process.env.REACT_APP_UI_BASE_URL) {
        return;
      }
      if (event.data?.type === OAuthStatus.Success) {
        const firms = await firmRefresh();
        const updatedCurrentFirm = firms.find((f) => f._id === currentFirm?._id);
        dispatch(setCurrentCompanyList(updatedCurrentFirm?.companies || []));
        // await userRefresh(dispatch);
        dispatch(setCurrentRealm(null));
        // dispatch(setInitialized(false));
        //TODO fix
        // const oldComp = companies?.find((c) => c.realmId === event?.data?.realmId);
        // if (oldComp) {
        //   dispatch(setCurrentFirm(oldComp));
        // }
        await dispatch(initializeApp() as any);
        navigate(MainRoute.User + UserRoute.Clients + `?realmId=${event.data.realmId}`, { replace: true });
      }
      if (event.data?.type === OAuthStatus.Error) {
        dispatch(setCurrentRealm(null));
        // dispatch(setInitialized(false));
        errorToast('Error while authorizing QuickBooks');
      }
      if (event.data?.type === OAuthStatus.AlreadyConnectedCompany) {
        warnToast(
          <span>
            Company <b>{event?.data?.companyName}</b> is already connected to QuickBooks in firm{' '}
            <b>{event?.data?.firmName}</b>. Please disconnect it first.
          </span>
        );
      }
      if (event.data?.type === OAuthStatus.DifferentRealmId) {
        dispatch(setCurrentRealm(null));
        // dispatch(setInitialized(false));
        errorToast(
          "Unable to connect: The company you're authorizing in Intuit doesn't match the one you've selected to connect"
        );
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);
  const loginWithIntuit = async (connectClient = false) => {
    let oauthUrl = '/v1/auth/oauth2/authUri';
    if (connectClient) {
      const params = new URLSearchParams({ connectClient: 'true' });
      oauthUrl += `?${params.toString()}`;
    }
    const response = await apiClient.post(oauthUrl);
    toast(<Msg />, { type: 'success', className: 'toast-message' });

    // Размеры окна
    const width = 620;
    const height = 700;

    // Рассчитываем позицию окна для его центрирования
    const left = window.screen.width / 2 - width / 2;
    const top = window.screen.height / 2 - height / 2;

    window.open(
      response.data,
      '_blank',
      `toolbar=no, menubar=no, width=${width}, height=${height}, top=${top}, left=${left}`
    );
  };
  const goToOauthPage = async (): Promise<{ isLimit: boolean }> => {
    const clientLimits = await apiClient.get<number>('/v1/firm/clients/limits', {
      params: { firmId: currentFirm?._id }
    });
    if (clientLimits.data <= 0) {
      return { isLimit: true };
    }
    await loginWithIntuit(true);
    return { isLimit: false };
  };

  return { goToOauthPage, loginWithIntuit };
};

export default useOAuth;
